import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import { mapActions } from "vuex";
import { LibraryPageApi } from "../../ApiInterface";
import Image from "@/assets/js/models/image/Image";
import { convertFileToDataUrl } from "../../mcn-helpers";
export default {
  name: "ResizableImageTemplate",
  components: {
    NodeViewWrapper,
    'vue-draggable-resizable': VueDraggableResizable
  },
  props: nodeViewProps,
  data() {
    return {
      onLoadImage: null,
      lockAspectRatio: false
    };
  },
  computed: {
    imgAttrs() {
      return Object.keys(this.node.attrs).reduce((init, nextKey) => {
        if (['src', 'alt', 'width', 'height'].includes(nextKey)) init[nextKey] = this.node.attrs[nextKey];
        return init;
      }, {});
    },
    isImageLoading: {
      get() {
        return this.node.attrs.isImageLoading;
      },
      set(isImageLoading) {
        this.updateAttributes({
          isImageLoading
        });
      }
    },
    width: {
      get() {
        return this.node.attrs.width;
      },
      set(width) {
        this.updateAttributes({
          width
        });
      }
    },
    height: {
      get() {
        return this.node.attrs.height;
      },
      set(height) {
        this.updateAttributes({
          height
        });
      }
    }
  },
  methods: {
    ...mapActions(['SendRequest']),
    onResize(x, y, width, height) {
      if (isNaN(width) || isNaN(height)) return;
      let editorMaxWidth = this.node.attrs.editorMaxWidth;
      let definitiveWidth = width > editorMaxWidth ? editorMaxWidth : width;
      let ratio = definitiveWidth / height;
      this.width = definitiveWidth;
      this.height = definitiveWidth / ratio;
    },
    onActivated() {
      this.lockAspectRatio = true;
    },
    async uploadImageToS3() {
      var _find, _this$node$attrs$imag;
      let file = (_find = ((_this$node$attrs$imag = this.node.attrs.imageData) !== null && _this$node$attrs$imag !== void 0 ? _this$node$attrs$imag : []).find(item => item.name === 'file')) === null || _find === void 0 ? void 0 : _find.value;
      (await this.SendRequest(LibraryPageApi.saveAndFetchSingleImage(this.node.attrs.imageData, 'form-data'))).OnStart(async () => this.onLoadImage = await convertFileToDataUrl(file)).OnSuccess(image => {
        this.node.attrs.src = image instanceof Image ? image.getUrl() : null;
        this.isImageLoading = false;
        this.initResizeDimensions();
      }, Image).OnFinished(() => this.isImageLoading = false);
    },
    initResizeDimensions() {
      this.$nextTick(() => {
        if (this.$refs.resizableImg) {
          this.$refs.resizableImg.onload = e => {
            let targetImage = e.target;
            let editorMaxWidth = this.node.attrs.editorMaxWidth;
            let imageWidth = targetImage.naturalWidth;
            let imageHeight = targetImage.naturalHeight;
            let preserveRatioCoefficient = imageWidth > editorMaxWidth ? editorMaxWidth / imageWidth : 1;
            this.width = imageWidth * preserveRatioCoefficient;
            this.height = imageHeight * preserveRatioCoefficient;
          };
        }
      });
    }
  },
  mounted() {
    if (this.$refs.resizableImg) {
      this.isImageLoading ? this.uploadImageToS3() : this.initResizeDimensions();
    }
  }
};